import { render, staticRenderFns } from "./remarksPopup.vue?vue&type=template&id=c894b90a&scoped=true"
import script from "./remarksPopup.vue?vue&type=script&lang=js"
export * from "./remarksPopup.vue?vue&type=script&lang=js"
import style0 from "./remarksPopup.vue?vue&type=style&index=0&id=c894b90a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c894b90a",
  null
  
)

export default component.exports